import React from "react";
import { mWarn } from "utils/logger";
import getData from "utils/getData";
import { graphQLClientMutationHelper, graphQLQueryHelper } from "utils/graphQL";
import SText from "styled42/components/SText";
import {
  pushClevertapEvent,
  pushClevertapProfile
} from "utils/clevertapEvents";
import {
  EDIT_CANDIDATE,
  LOGGED_IN_USER_DATA,
  LOGGED_OUT_USER_DATA
} from "../../queries";

export const MandatorySText = ({ text }) => (
  <SText size={12}>
    {text}
    <SText color="red">*</SText>
  </SText>
);

export const getInitialStateValue = ({ user }) => {
  let genderValue = null;
  let proficiencyLevel = null;
  let educationId = null;
  const { first_name, last_name, gender, date_of_birth, stakeholder } = user;
  if (stakeholder && stakeholder?.educations?.length > 0) {
    proficiencyLevel = stakeholder?.educations[0]?.proficiency_level;
    educationId = stakeholder?.educations[0]?.id;
  }
  if (Object.values(genderEnum).includes(gender)) {
    genderValue = gender;
  }

  let full_name = last_name ? `${first_name} ${last_name}` : first_name;

  return {
    fullName: full_name,
    gender: genderValue,
    proficiencyLevel,
    dob: date_of_birth,
    educationId
  };
};

export const genderEnum = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  OTHER: "OTHER"
};

export const genderLabel = {
  MALE: "Male",
  FEMALE: "Female",
  OTHER: "Other"
};

export const monthNameObj = {
  "00": "Select month",
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  10: "October",
  11: "November",
  12: "December"
};

export const qualificationOptions = [
  {
    text: "Below 10th",
    value: "LESS_THAN_10",
    vernacKey: "generic_below_10"
  },
  {
    text: "10th pass",
    value: "TENTH",
    vernacKey: "generic_pass_10"
  },
  {
    text: "12th pass",
    value: "TWELFTH",
    vernacKey: "generic_pass_12"
  },
  {
    text: "Pursuing Graduation",
    value: "PURSUING_GRADUATION",
    vernacKey: "generic_pursuing_graduation"
  },
  {
    text: "Graduate",
    value: "GRADUATE",
    vernacKey: "generic_graduate"
  },
  {
    text: "Post Graduate",
    value: "POST_GRADUATE",
    vernacKey: "generic_post_graduate"
  }
];

export const getMonthArray = () => {
  const monthArray = [];
  for (let i = 0; i <= 12; i += 1) {
    if (i < 10) monthArray.push(`0${i}`);
    else monthArray.push(`${i}`);
  }
  return monthArray;
};

export const getYearArray = () => {
  const yearArray = ["Select year"];
  let currentYear = new Date();
  currentYear = currentYear.getFullYear();
  for (let i = currentYear - 14; i >= currentYear - 100; i -= 1) {
    yearArray.push(`${i}`);
  }
  return yearArray;
};

export const onSubmitHandler = async ({
  goNext,
  client,
  state,
  fullName,
  gender,
  dob,
  qualification,
  educationId
}) => {
  let { user, variant } = state;
  let stakeholderId = getData(user, "stakeholder.id");

  // If stakeholderId is not found in user -> Again fetch user data
  if (!stakeholderId) {
    const { data } = await graphQLQueryHelper(client)({
      query: LOGGED_OUT_USER_DATA,
      variables: {
        userId: user.id
      }
    });
    if (data && data?.node && data?.node?.stakeholder) {
      user = data?.node;
      stakeholderId = data?.node?.stakeholder?.id;
    }
  }

  const userPayload = {
    full_name: fullName,
    gender
    //date_of_birth: dob
  };
  let educationObj = { proficiency_level: qualification };
  if (educationId) educationObj = { ...educationObj, id: educationId };
  const educationPayload = [educationObj];

  const payload = {
    user: userPayload
    //educations: educationPayload
  };
  const { data, error } = await graphQLClientMutationHelper(client)({
    mutation: EDIT_CANDIDATE,
    variables: {
      payload,
      id: stakeholderId
    },
    refetchQueries: [{ query: LOGGED_IN_USER_DATA }]
  });

  if (error) {
    mWarn("error", error);
    return;
  }
  pushClevertapEvent("loginRegister Clicks", {
    Current_Page: "New loginRegistration",
    Page_Modal: "Personal Details Page 1",
    Test_Case: variant,
    Type: "Next"
  });

  const educationText = qualificationOptions.filter((obj) => {
    return obj.value === qualification;
  });

  const DOBArray = dob.split("-");

  if (data && data.edit) {
    const userData = {
      ...user,
      full_name: fullName,
      first_name: data.edit.user.first_name,
      last_name: data.edit.user.last_name,
      gender,
      date_of_birth: dob,
      stakeholder: {
        ...user?.stakeholder,
        educations: getData(data, "edit.educations")
      }
    };

    // DOBArray[1] - 1 added because of index
    pushClevertapProfile({
      Name: userData.first_name,
      DOB: new Date(DOBArray[0], DOBArray[1] - 1, 15, 3, 59, 0),
      Gender: gender === "MALE" ? "M" : "F",
      Test_Case: variant,
      Candidate_Name: userData.first_name,
      "Candidate Name": userData.first_name,
      Identity: user.id,
      Candidate_DOB: new Date(DOBArray[0], DOBArray[1] - 1, 15, 3, 59, 0),
      "Candidate DOB": new Date(DOBArray[0], DOBArray[1] - 1, 15, 3, 59, 0),
      Candidate_Gender: gender === "MALE" ? "M" : "F",
      Candidate_Education:
        educationText && educationText.length > 0 ? educationText[0].text : "",
      "Candidate Education":
        educationText && educationText.length > 0 ? educationText[0].text : ""
    });

    goNext({
      user: userData
    });
  }
};
